module.exports = __webpack_public_path__ + "static/img/gamma.90a8257a.svg";